import { render, staticRenderFns } from "./MobileButton.vue?vue&type=template&id=21b6bdae&scoped=true&"
import script from "./MobileButton.vue?vue&type=script&lang=js&"
export * from "./MobileButton.vue?vue&type=script&lang=js&"
import style0 from "./MobileButton.vue?vue&type=style&index=0&id=21b6bdae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6bdae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VDialog,VIcon,VOverlay})
